import React from "react"
import Slider from "react-slick"
import { CmsAsset, CmsImage } from "../../models/common"

import Image from "../Image/Image"
import LinkWrapper from "../LinkWrapper"

import { PageModels } from "../../models/pages"
import { AnchorModel } from "../../models/nav"
import { ImageSliderModule } from "../../models/modules"

interface Props extends ImageSliderModule {
  pageContext: any
}

const defaultProps = {}

export const ImageSlider: React.FC<Props> = props => {
  if (!props.slides) return null

  const sliderSettings = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <section>
      <div className="grid-x grid-margin-x align-center">
        <div className="cell">
          {props.heading && (
            <h2
              className={props.center_title ? "text-center" : ""}
              style={{ marginBottom: 30 }}
            >
              {props.heading}
            </h2>
          )}
        </div>
        <div className="cell small-10">
          {props.slides.length > 1 && (
            <Slider {...sliderSettings} className="imageSlider">
              {props.slides.map((slide, i) => {
                if (slide?.image)
                  return (
                    <ImageSlide
                      key={`slide_${i}`}
                      {...slide}
                      pageContext={props.pageContext}
                    />
                  )
              })}
            </Slider>
          )}
        </div>
      </div>
    </section>
  )
}

ImageSlider.defaultProps = defaultProps

export default ImageSlider

interface ImageSlideProps {
  key: string
  slide_name?: string
  show_name?: boolean
  image: CmsImage
  url?: string
  entry?: PageModels[]
  asset?: CmsAsset
  new_window?: boolean
  pageContext: any
}

const ImageSlide: React.FC<ImageSlideProps> = props => {
  const link: AnchorModel = {
    id: props.key,
    url: props.url,
    entry: props.entry,
    asset: props.asset,
    new_window: props.new_window,
    internal: { type: "Contentstack_anchor" },
  }

  return (
    <LinkWrapper
      anchor={[link]}
      cssClass="imageSlide__link"
      pageContext={props.pageContext}
    >
      <>
        <Image image={props.image} />
        {props.show_name && props.slide_name && (
          <div className="imageSlide__heading">{props.slide_name}</div>
        )}
      </>
    </LinkWrapper>
  )
}
